import { isGenAiLogomakerAvailable } from './featureAvailability';
import type { Locale as VistaLocale } from '../i18n/config';

export const sharedVista99dLocales = [
    'en-AU',
    'de-AT',
    'en-AT',
    'nl-BE',
    'fr-BE',
    'en-BE',
    'pt-BR',
    'en-BR',
    'en-CA',
    'fr-CA',
    'es-CL',
    'en-CL',
    'es-CO',
    'en-CO',
    'de-CH',
    'fr-CH',
    'it-CH',
    'en-CH',
    'de-DE',
    'en-DE',
    'da-DK',
    'en-DK',
    'es-ES',
    'en-ES',
    'fi-FI',
    'fr-FR',
    'en-FR',
    'en-GB',
    'en-HK',
    'en-IE',
    'en-IN',
    'it-IT',
    'en-IT',
    'ja-JP',
    'en-JP',
    'es-MX',
    'en-MX',
    'nl-NL',
    'en-NL',
    'en-NO',
    'nb-NO',
    'en-NZ',
    'pt-PT',
    'en-PT',
    'en-SG',
    'sv-SE',
    'en-US',
    'es-US',
] as const;

export type Vista99dLocale = (typeof sharedVista99dLocales)[number];

const vistaprintDomains: Record<Vista99dLocale, string> = {
    'en-AU': 'https://www.vistaprint.com.au',
    'de-AT': 'https://www.vistaprint.at',
    'en-AT': 'https://www.vistaprint.at', // Fallback to de-AT
    'nl-BE': 'https://www.vistaprint.be',
    'en-BE': 'https://www.vistaprint.be', // Fallback to nl-BE
    'fr-BE': 'https://www.vistaprint.be/fr',
    'en-BR': 'https://www.vistaprint.com', // Fallback to en-US
    'pt-BR': 'https://www.vistaprint.com', // Fallback to en-US
    'en-CA': 'https://www.vistaprint.ca',
    'fr-CA': 'https://www.vistaprint.ca/fr',
    'es-CL': 'https://www.vistaprint.com/es', // Fallback to es-US
    'en-CL': 'https://www.vistaprint.com', // Fallback to en-US
    'es-CO': 'https://www.vistaprint.com/es', // Fallback to es-US
    'en-CO': 'https://www.vistaprint.com', // Fallback to en-US
    'de-CH': 'https://www.vistaprint.ch',
    'fr-CH': 'https://www.vistaprint.ch/fr',
    'it-CH': 'https://www.vistaprint.ch/it',
    'en-CH': 'https://www.vistaprint.ch', // Fallback to de-CH
    'de-DE': 'https://www.vistaprint.de',
    'en-DE': 'https://www.vistaprint.de', // Fallback to de-DE
    'da-DK': 'https://www.vistaprint.dk',
    'en-DK': 'https://www.vistaprint.dk', // Fallback to da-DK
    'es-ES': 'https://www.vistaprint.es',
    'en-ES': 'https://www.vistaprint.es', // Fallback to es-ES
    'fi-FI': 'https://www.vistaprint.fi',
    'fr-FR': 'https://www.vistaprint.fr',
    'en-FR': 'https://www.vistaprint.fr', // Fallback to fr-FR
    'en-GB': 'https://www.vistaprint.co.uk',
    'en-HK': 'https://www.vistaprint.com', // Fallback to en-US
    'en-IE': 'https://www.vistaprint.ie',
    'en-IN': 'https://www.vistaprint.in',
    'it-IT': 'https://www.vistaprint.it',
    'en-IT': 'https://www.vistaprint.it', // Fallback to it-IT
    'ja-JP': 'https://www.vistaprint.com', // Fallback to en-US
    'en-JP': 'https://www.vistaprint.com', // Fallback to en-US
    'es-MX': 'https://www.vistaprint.com/es', // Fallback to es-US
    'en-MX': 'https://www.vistaprint.com', // Fallback to en-US
    'en-NL': 'https://www.vistaprint.nl', // Fallback to nl-NL
    'nl-NL': 'https://www.vistaprint.nl',
    'en-NO': 'https://www.vistaprint.no', // Fallback to nb-NO
    'nb-NO': 'https://www.vistaprint.no',
    'en-NZ': 'https://www.vistaprint.co.nz',
    'en-PT': 'https://www.vistaprint.pt', // Fallback to pt-PT
    'pt-PT': 'https://www.vistaprint.pt',
    'en-SG': 'https://www.vistaprint.sg',
    'sv-SE': 'https://www.vistaprint.se',
    'en-US': 'https://www.vistaprint.com',
    'es-US': 'https://www.vistaprint.com/es',
};

const ninetyNineDomains: Record<Vista99dLocale, string> = {
    'en-AU': 'https://99designs.com.au',
    'de-AT': 'https://99designs.at',
    'en-AT': 'https://en.99designs.at',
    'nl-BE': 'https://99designs.be',
    'en-BE': 'https://en.99designs.be',
    'fr-BE': 'https://fr.99designs.be',
    'en-BR': 'https://en.99designs.com.br',
    'pt-BR': 'https://99designs.com.br',
    'en-CA': 'https://99designs.ca',
    'fr-CA': 'https://99designs.ca', // Fallback to en-CA
    'es-CL': 'https://99designs.cl',
    'en-CL': 'https://en.99designs.cl',
    'es-CO': 'https://99designs.com.co',
    'en-CO': 'https://en.99designs.com.co',
    'de-CH': 'https://99designs.ch',
    'fr-CH': 'https://fr.99designs.ch',
    'it-CH': 'https://it.99designs.ch',
    'en-CH': 'https://en.99designs.ch',
    'de-DE': 'https://99designs.de',
    'en-DE': 'https://en.99designs.de',
    'da-DK': 'https://99designs.dk', // Fallback to en-DK
    'en-DK': 'https://99designs.dk',
    'es-ES': 'https://99designs.es',
    'en-ES': 'https://en.99designs.es',
    'fi-FI': 'https://99designs.com', // Fallback to en-US
    'fr-FR': 'https://99designs.fr',
    'en-FR': 'https://en.99designs.fr',
    'en-GB': 'https://99designs.co.uk',
    'en-HK': 'https://99designs.hk',
    'en-IE': 'https://99designs.ie',
    'en-IN': 'https://99designs.com', // Fallback to en-US
    'it-IT': 'https://99designs.it',
    'en-IT': 'https://en.99designs.it',
    'ja-JP': 'https://99designs.jp',
    'en-JP': 'https://en.99designs.jp',
    'es-MX': 'https://99designs.com.mx',
    'en-MX': 'https://en.99designs.com.mx',
    'en-NL': 'https://en.99designs.nl',
    'nl-NL': 'https://99designs.nl',
    'en-NO': 'https://en.99designs.no',
    'nb-NO': 'https://99designs.com', // Fallback to en-US
    'en-NZ': 'https://99designs.com.au', // Fallback to en-AU
    'en-PT': 'https://en.99designs.pt',
    'pt-PT': 'https://99designs.pt',
    'en-SG': 'https://99designs.com.sg',
    'sv-SE': 'https://99designs.com', // Fallback to en-US
    'en-US': 'https://99designs.com',
    'es-US': 'https://es.99designs.com',
};

export const bifrostEnabledLocales: Vista99dLocale[] = ['en-US', 'en-AU'];

const getLanguagePrefixPath = (locale: VistaLocale): string => {
    const langPrefixMap: Partial<Record<VistaLocale, string>> = {
        'fr-BE': '/fr',
        'fr-CA': '/fr',
        'fr-CH': '/fr',
        'es-US': '/es',
        'it-CH': '/it',
    };
    return langPrefixMap[locale] || '';
};

export const ninetyNineDomainByLocale = (locale: Vista99dLocale): string =>
    ninetyNineDomains[locale] ?? ninetyNineDomains['en-US'];

export const ninetyNineLogoDesignUrl = (locale: Vista99dLocale = 'en-US'): string =>
    `${ninetyNineDomainByLocale(locale)}/logo-design`;

export const ninetyNineLogoDesignPDPUrl = (locale: Vista99dLocale = 'en-US'): string =>
    `${ninetyNineDomainByLocale(locale)}/logo-design/details`;

export const ninetyNineMoneyBackGuaranteeUrl = (): string =>
    'https://support.99designs.com/hc/en-us/articles/204108729-100-Money-back-guarantee-For-real';

export const ninetyNineHowContestsWorkUrl = (): string =>
    'https://support.99designs.com/hc/en-us/articles/204109459-How-long-do-design-contests-take-and-what-s-involved';

export const vistaprintDomainByLocale = (locale: Vista99dLocale): string =>
    vistaprintDomains[locale] || vistaprintDomains['en-US'];

export const proLogoDesignUrl = (locale: Vista99dLocale = 'en-US'): string => {
    if (bifrostEnabledLocales.includes(locale)) {
        // Bifrost locales go to Vista Pro Logo Design (logo-essential) PDP
        return `${vistaprintDomainByLocale(locale)}/experts/services/details/logoessential`;
    }
    // All other locales go to 99designs Pro Logo Design (logo-essential) PDP
    return `${ninetyNineDomainByLocale(locale)}/logo-essential/details`;
};

export const logoInspirationBasePath = '/logomaker/ideas';

export const logoInspirationRootUrl = (): string =>
    `${vistaprintDomains['en-US']}${logoInspirationBasePath}`;

export const logoInspirationKeywordPath = (keyword: string): string =>
    `${logoInspirationBasePath}/${keyword}-logos`;

export const logoInspirationKeywordUrl = (keyword: string): string =>
    `${vistaprintDomains['en-US']}${logoInspirationKeywordPath(keyword)}`;

const logomakerClassicWizardPath = (locale: VistaLocale = 'en-US'): string => {
    if (locale === 'fr-FR') {
        return '/logo/creation-logo/wizard';
    }
    const langPrefix = getLanguagePrefixPath(locale);
    return `${langPrefix}/logomaker/wizard`;
};

const logomakerGenAiPath = (locale: VistaLocale): string => {
    if (locale === 'fr-FR') {
        return '/logo/creation-logo/genai';
    }
    const langPrefix = getLanguagePrefixPath(locale);
    return `${langPrefix}/logomaker/genai`;
};

export const logomakerCtaPathByLocale = (locale: VistaLocale): string => {
    return isGenAiLogomakerAvailable(locale as VistaLocale)
        ? logomakerGenAiPath(locale)
        : logomakerClassicWizardPath(locale);
};

export const logomakerLandingPagePathByLocale = (locale: VistaLocale): string => {
    if (locale === 'fr-FR') {
        return '/creation-logo';
    }
    const langPrefix = getLanguagePrefixPath(locale);
    return `${langPrefix}/logomaker`;
};

export const logoDesignLandingPagePathByLocale = (locale: VistaLocale): string => {
    const langPrefix = getLanguagePrefixPath(locale);
    return `${langPrefix}/logo-design`;
};
